/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Website_CtaInputs */

const et_plan_website_cta = /** @type {(inputs: Plan_Website_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soovin uut veebilehte`)
};

const en_plan_website_cta = /** @type {(inputs: Plan_Website_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want a new website`)
};

/**
* | output |
* | --- |
* | "I want a new website" |
*
* @param {Plan_Website_CtaInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_website_cta = /** @type {((inputs?: Plan_Website_CtaInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Website_CtaInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_website_cta(inputs)
	return en_plan_website_cta(inputs)
});